module.exports = __webpack_public_path__ + "static/media/avatar-1-profile.23b6beb1.png";